import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

// Like UserIcon, but:
//   * Falls back to initials instead of showing the placeholder photo (unless told otherwise)
//   * Has styles included
export default function PhotoOrInitials({ fallBackToInitials = true, size = 32, user }) {
  const style = { width: size, height: size };

  if (!user.hasImage && fallBackToInitials) {
    return (
      <div className="photo-or-initials initials" style={style}>
        {user.initials}
      </div>
    );
  } else {
    return (
      <img
        className="photo-or-initials photo img-circle rounded-circle bs5-img-thumbnail"
        src={user.imageUrl}
        style={style}
        title={user.name || user.email}
      />
    );
  }
}

PhotoOrInitials.propTypes = {
  fallBackToInitials: PropTypes.bool,
  size: PropTypes.number,
  user: PropTypes.shape({
    email: PropTypes.string,
    hasImage: PropTypes.bool,
    imageUrl: PropTypes.string,
    initials: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};
